import { LoadingButton } from "@mui/lab";
import { CircularProgress } from "@mui/material";
import React from "react";

const NewFormSubmitButton = (props) => {

  return (
    <LoadingButton
      disabled={props.disabled}
      variant={props.variant ?? "contained"}
      color={props.color}
      onClick={props.onClick}
      loading={props.loading}
      loadingIndicator={<CircularProgress size={20} />}
      type="submit"
      {...props}
    >
      {props.text ? props.text : "Save"}
    </LoadingButton>
  );
};

export default NewFormSubmitButton;